import React, { useState, useEffect } from 'react';
import { List, ListItem, ListItemText, ListItemIcon, Collapse } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ConstructionIcon from '@mui/icons-material/Construction';
import RadioIcon from '@mui/icons-material/Radio';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import PersonAddDisabledIcon from '@mui/icons-material/PersonAddDisabled';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import AlarmIcon from '@mui/icons-material/Alarm';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import UndoIcon from '@mui/icons-material/Undo';
import BugReportIcon from '@mui/icons-material/BugReport';
import { Link } from 'react-router-dom';
import { EvaluarPermiso } from '../../Genericos/Generales';
import { menuItemStyles } from '../../Tools/MenuItemStyles';

const Configuracion = ({ sesionUsuario }) => {
  const [configuracion, setConfiguracion] = useState(false);
  const [crearTiposCampanas, setCrearTiposCampanas] = useState(false);
  const [crearTiposTareas, setCrearTiposTareas] = useState(false);
  const [asignarRolesUsuarios, setAsignarRolesUsuarios] = useState(false);
  const [administrarRoles, setAdministrarRoles] = useState(false);
  const [auditoria, setAuditoria] = useState(false);
  const [configurarAlerta, setConfigurarAlerta] = useState(false);
  const [importarExcel, setImportarExcel] = useState(false);
  const [asignarExcel, setAsignarExcel] = useState(false);
  const [reporteBug, setReporteBug] = useState(false);
  const [revertirExcel, setRevertirExcel] = useState(false);
  const [openArchivo, setOpenArchivo] = useState(false);

  const handleOpenArchivo = () => {
    setOpenArchivo(!openArchivo);
  };

  useEffect(() => {
    const permisos = sesionUsuario.usuario.pantallasUsuario.listaPantallasRol;
    setConfiguracion(EvaluarPermiso(permisos, '/configuracion'));
    setCrearTiposCampanas(EvaluarPermiso(permisos, '/tiposcampanas'));
    setCrearTiposTareas(EvaluarPermiso(permisos, '/tipostareas'));
    setAsignarRolesUsuarios(EvaluarPermiso(permisos, '/usuariosRoles'));
    setAdministrarRoles(EvaluarPermiso(permisos, '/rol'));
    setAuditoria(EvaluarPermiso(permisos, '/auditoria'));
    setConfigurarAlerta(EvaluarPermiso(permisos, '/configurarAlerta'));
    setImportarExcel(EvaluarPermiso(permisos, '/importarExcel'));
    setAsignarExcel(EvaluarPermiso(permisos, '/asignarExcel'));
    setReporteBug(EvaluarPermiso(permisos, '/reportarBug'));
    setRevertirExcel(EvaluarPermiso(permisos, '/revertirExcel'));
  }, [sesionUsuario]);

  return (
    <>
      {configuracion && (
        <>
          <ListItem button onClick={handleOpenArchivo} sx={menuItemStyles.expandableHeader}>
            <ListItemIcon sx={menuItemStyles.menuIcon}>
              <ConstructionIcon />
            </ListItemIcon>
            <ListItemText primary="Configuración" sx={menuItemStyles.menuText} />
            {openArchivo ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openArchivo} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {crearTiposCampanas && (
                <ListItem button component={Link} to="/tiposcampanas" sx={menuItemStyles.subMenuItem}>
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <RadioIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Crear Tipos de Campañas" sx={menuItemStyles.subMenuText} />
                </ListItem>
              )}
              {crearTiposTareas && (
                <ListItem button component={Link} to="/tipostareas" sx={menuItemStyles.subMenuItem}>
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <ShoppingBagIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Crear Tipos de Tareas" sx={menuItemStyles.subMenuText} />
                </ListItem>
              )}
              {asignarRolesUsuarios && (
                <ListItem button component={Link} to="/usuariosRoles" sx={menuItemStyles.subMenuItem}>
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <PersonAddDisabledIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Asignar Roles a Usuarios" sx={menuItemStyles.subMenuText} />
                </ListItem>
              )}
              {administrarRoles && (
                <ListItem button component={Link} to="/rol" sx={menuItemStyles.subMenuItem}>
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <AdminPanelSettingsIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Administrar Roles" sx={menuItemStyles.subMenuText} />
                </ListItem>
              )}
              {auditoria && (
                <ListItem button component={Link} to="/auditoria" sx={menuItemStyles.subMenuItem}>
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <RemoveRedEyeIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Auditoria" sx={menuItemStyles.subMenuText} />
                </ListItem>
              )}
              {configurarAlerta && (
                <ListItem button component={Link} to="/configurarAlerta" sx={menuItemStyles.subMenuItem}>
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <AlarmIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Configuracion de Alertas" sx={menuItemStyles.subMenuText} />
                </ListItem>
              )}
              {importarExcel && (
                <ListItem button component={Link} to="/importarExcel" sx={menuItemStyles.subMenuItem}>
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <ReceiptLongIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Importar Excel (Mis Documentos)" sx={menuItemStyles.subMenuText} />
                </ListItem>
              )}
              {asignarExcel && (
                <ListItem button component={Link} to="/asignarExcel" sx={menuItemStyles.subMenuItem}>
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <ReceiptLongIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Importar Excel (Para otro Usuario)" sx={menuItemStyles.subMenuText} />
                </ListItem>
              )}
              {revertirExcel && (
                <ListItem button component={Link} to="/revertirExcel" sx={menuItemStyles.subMenuItem}>
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <UndoIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Revertir Importaciones" sx={menuItemStyles.subMenuText} />
                </ListItem>
              )}
              {reporteBug && (
                <ListItem button component={Link} to="/reportarBug" sx={menuItemStyles.subMenuItem}>
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <BugReportIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Reporte de Bugs" sx={menuItemStyles.subMenuText} />
                </ListItem>
              )}
            </List>
          </Collapse>
        </>
      )}
    </>
  );
};

export default Configuracion;
